'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarInfoDetails = renderWithRef('PriceBarInfoDetails', null, (o, t)=>{
    let { children: a } = o;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: new Set([
            'swan-price-bar-main-info-details'
        ]),
        props: o,
        children: a
    });
});

export { PriceBarInfoDetails };
